import { render, staticRenderFns } from "./Habit.vue?vue&type=template&id=4845f6ff&scoped=true&"
import script from "./Habit.vue?vue&type=script&lang=js&"
export * from "./Habit.vue?vue&type=script&lang=js&"
import style0 from "./Habit.vue?vue&type=style&index=0&id=4845f6ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845f6ff",
  null
  
)

export default component.exports